import React from 'react';

//UI components
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Button } from 'components/form/Button';
import Label from 'components/form/Label/Label';
import SectionContainer from 'components/Containers/SectionContainer';
import { Row } from 'components/Containers/Row/Row';

//tracking sensor
import VisibilitySensor from 'react-visibility-sensor';

import './PremiumUpsell.scss';

export const PremiumUpsell = props => {
  const {
    displayClasses,
    onVisibilityChange,
    handleCTAClick,
    belowBandCreditScore,
  } = props;
  let primaryText = 'Track your credit score daily';
  let secondaryText = '3 Bureau credit score & report, real time alerts & more';
  let buttonText = 'Get Options';
  if (!belowBandCreditScore) {
    primaryText = 'Get more with Sesame Premium';
    secondaryText =
      'Live experts to help you with ID theft restoration, 3B Credit reports & real time alerts';
    buttonText = 'Get Protected';
  }

  return (
    <SectionContainer id="Premium-upsell" className={`${displayClasses}`}>
      <VisibilitySensor onChange={onVisibilityChange}>
        <div className="invisible-pixel" />
      </VisibilitySensor>
      <Row type="offerCardRow">
        <FlexContainer className="justify-between flex-mobile-col align-items-center">
          <FlexContainer className="format80 t-format80 m-format100 flex-mobile-col align-items-center">
            <div className="upsell-img m-format100"></div>
            <div className="upsell-copy padL24 padR8 m-killPad format66 m-format100">
              <Label type="H3" typeHeader={'h3'} className="h1-copy">
                {primaryText}
              </Label>
              <Label type="Body-1" className="h2-copy margT8">
                {secondaryText}
              </Label>
            </div>
          </FlexContainer>
          <div className="format20 t-format20 m-format100 m-margT16">
            <Button
              mrphType="primary"
              className="upsell-CTA fullWidth"
              onClick={handleCTAClick}
            >
              <Label className="upsell-btn-copy">{buttonText}</Label>
            </Button>
          </div>
        </FlexContainer>
      </Row>
    </SectionContainer>
  );
};
